<template>
  <div>
    <el-form :model="ruleForm" status-icon :label-position="labelPosition"  :rules="rules" ref="ruleForm" label-width="80px">
      <el-form-item prop="userName" label=" " class="inputBox"  >
        <el-input class="input" v-model="ruleForm.userName" placeholder="登录名">
          <i slot="prefix" class="el-input__icon el-icon-edit-outline"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="pswd" label=" " class="inputBox" >
        <el-input class="input" type="password" v-model="ruleForm.pswd" placeholder="密码">
          <i slot="prefix" class="el-input__icon el-icon-goods"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="email" label=" " class="inputBox"  >
        <el-input class="input" v-model="ruleForm.email" placeholder="请输入邮箱获取验证码">
          <i slot="prefix" class="el-input__icon el-icon-edit-outline"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="securityCode" class="test">
        <el-input class="input input1" v-model="ruleForm.securityCode" placeholder="验证码"></el-input>
        <div class="btnCord" @click="btnCord" v-if="codeShow === true">获取验证码</div>
        <div class="countDown" v-if="codeShow === false">{{countDown}}秒后重新获取</div>
        <div style="color:red">{{mistake}}</div>
      </el-form-item>
      <el-form-item>
        <div class="submitForm" type="primary" @click="verify()">注册</div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import * as req from '@/utils/request'
export default {
  props: [true],
  data () {
    let repetitionUsrName = (rule, value, callback) => {
      // this.nameBlur()
      if (!this.repetition) {
        callback(new Error('登录名已存在'))
      } else {
        callback()
      }
    }
    let validatePswd = (rule, value, callback) => {
      this.$refs.ruleForm.validateField('checkPass')
      callback()
    }
    let validateName = (rule, value, callback) => {
      let str = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      let reg = new RegExp(str)
      if (!reg.test(value)) {
        callback(new Error('邮箱格式错误'))
      } else {
        callback()
      }
    }
    let repetitionName = (rule, value, callback) => {
      if (!this.repetition) {
        callback(new Error('邮箱已存在'))
      } else {
        callback()
      }
    }
    return {
      labelPosition: 'right',
      // 验证码错误信息显示
      mistake: '',
      // 验证邮箱是否存在
      repetition: true,
      // 获取验证码等待
      codeShow: true,
      emailInfo: '',
      // 获取验证码倒计时
      countDown: 60,
      arr: null,

      ruleForm: {
        name: '',
        pswd: '',
        checkPass: '',
        securityCode: '',
        phone: '',
        userName: '',
        email: ''
      },
      rules: {
        userName: [
          {required: true, message: '登录名不能为空', trigger: 'blur'},
          { min: 4, message: '长度不能小于4个字符', trigger: 'blur' },
          { validator: repetitionUsrName, trigger: 'blur' }
        ],
        pswd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' },
          { validator: validatePswd, trigger: 'blur' }
        ],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          { validator: validateName, trigger: 'blur' },
          { validator: repetitionName, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ruleFormUserName () {
      return this.ruleForm.userName
    }
  },
  watch: {
    ruleFormUserName (val, sel) {
      let str = val.indexOf('@')
      let strSum = val.indexOf('.')
      if (str !== -1 && strSum !== -1) {
        this.nameBlur()
      }
    }
  },
  methods: {
    sendMsg () {
      this.$emit('sendMsg', 0)
    },
    // 登录名失去焦点判断是否存在
    nameBlur () {
      let sendData = {}
      let obj = {}
      let filter = {}
      filter.logName = this.ruleForm.userName
      obj.filter = filter
      sendData.data = obj
      sendData.fn = this.nameBlurCallBack
      sendData.vm = this
      req.Post('web/get_userinfo', sendData)
    },
    nameBlurCallBack (data) {
      if (data === null) {
        alert('服务器未连接')
        this.repetition = false
        return
      }
      if (data.err_code === 0) {
        this.repetition = false
        return
      }
      this.repetition = true
    },
    // 提交
    submitForm (data) {
      let _this = this
      this.$refs[data].validate((valid) => {
        if (valid) {
          let sun = _this.mistake
          if (sun !== '') {
            return
          }
          let pwd = this.$md5(_this.ruleForm.pswd)
          let sendData = {}
          let obj = {}
          obj.log_name = _this.ruleForm.userName
          obj.pwd = pwd
          obj.securityCode = _this.ruleForm.securityCode
          obj.email = _this.ruleForm.email
          sendData.data = obj
          sendData.fn = _this.submitCallBack
          sendData.vm = _this
          req.Post('web/register', sendData)
        }
      })
    },
    // 提交回调
    submitCallBack (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      alert('注册成功')
      // 注册成功回到登录界面
      this.sendMsg()
      // 清空注册列表
      this._empty()
    },
    // 获取验证码
    btnCord () {
      if (!this.repetition) {
        return
      }
      let str = this.ruleForm.email
      if (str.indexOf('@') === -1 || str.indexOf('.com') === -1) {
        alert('请先填写邮箱')
        return
      }
      let sendData = {}
      let obj = {}
      obj.email = this.ruleForm.email
      sendData.data = obj
      sendData.fn = this.btnCordCallBack
      sendData.vm = this
      req.Get('web/send_check_code', sendData)
    },
    // 获取验证码回调函数
    btnCordCallBack (data) {
      if (data === null) {
        alert('与服务器未连接')
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.codeShow = false
      let _this = this
      let setInt = setInterval(function () {
        _this.countDown--
        if (_this.countDown === 0) {
          _this.codeShow = true
          clearInterval(setInt)
          _this.countDown = 60
        }
      }, 1000)
    },
    // 验证验证码是否一致
    verify () {
      let sendData = {}
      let obj = {}
      obj.email = this.ruleForm.email
      let str = this.ruleForm.securityCode
      obj.code = str
      sendData.data = obj
      sendData.fn = this.verifyCallBack
      sendData.vm = this
      req.Get('web/compare_check_code', sendData)
    },
    // 验证验证码是否一致回调
    verifyCallBack (data) {
      if (data === null) {
        alert('服务器未连接')
        this.mistake = '服务器未连接'
        return
      }
      if (data.err_code !== 0) {
        this.mistake = data.err_msg
        return
      }
      this.mistake = ''
      this.submitForm('ruleForm')
    },
    // 清空注册列表
    _empty () {
      this.$refs['ruleForm'].resetFields()
    }
  }
}
</script>
<style scoped>
.input{
  width: 403px;
  background: #ededed;
  /* margin:10px 0 0 0; */
}
.inputBox{
  margin:30px 0 0 0 !important
}
.input1{
  width: 200px;
}
.btnCord{
  width: 150px;
  height: 52px;
  display: inline-block;
  /* background: url(../assets/btn/获取验证码正常.png); */
  cursor: pointer;
  vertical-align: bottom;
  position: relative;
  top: 7px;
  text-align: center;
  background-color: #259cbf;
  color: white;
  font-size: 19px;
  border-radius: 50px;
  line-height: 51px;
  right: -41px;
  box-shadow: 4px 5px 10px 5px rgb(189, 231, 243);
}
.btnCord:hover{
  /* background: url('../assets/btn/获取验证码悬浮.png'); */
  background-color: #259bbf9f;
}
.countDown{
  width: 150px;
  height: 52px;
  display: inline-block;
  vertical-align: bottom;
  position: relative;
  top: 7px;
  text-align: center;
  background-color: #259cbf;
  color: white;
  font-size: 19px;
  border-radius: 50px;
  line-height: 51px;
  right: -41px;
  box-shadow: 4px 5px 10px 5px rgb(189, 231, 243);
}
.countDown:hover{
  background-color: #259bbf9f;
  cursor: not-allowed;
}
.submitForm{
    width: 259px;
    height: 70px;
    background-color: #259cbf;
    /* background: url(../assets/btn/注册正常.png); */
    cursor: pointer;
    margin: 10px 0 0 40px;
    border-radius: 50px;
    color: white;
    font-size: 40px;
    text-align: center;
    line-height: 1.8;
    margin-left: 68px;
    box-shadow: 4px 5px 10px 5px rgb(189, 231, 243);
}
.submitForm:hover{
  /* background: url('../assets/btn/注册悬浮.png'); */
  background-color: #259bbf9f;
}
.test{
  margin-top: 20px;
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/hgRegister1.vue